import React, { memo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Root from "./Root";

function PopulateAllowedRoutes({ routes }) {

  function handleChildRoutes(route) {

    if (!route.children) {
      return;
    }

    return (
      route.children.map((child, i) => {
        return (
          <Route
            key={i}
            path={child.path}
            element={child.element}
          >
          </Route>
        )
      }))
  }

  return (
    <Routes>
      <Route path="/" element={<Root />} >
        {
          routes.map((route, i) => {

            return (
              <Route
                key={i}
                path={route.path}
                element={route.element}
              >
                {
                  handleChildRoutes(route)
                }
              </Route>
            )
          })
        }
      </Route>
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  )
}

export default memo(PopulateAllowedRoutes);